import { makeStyles } from "@mui/styles";
export const useStyles = makeStyles(({ palette, spacing }) => ({
    ui_alert: ({ gutterBottom, align, hideIcon }) => ({
        marginBottom: gutterBottom ? spacing(2) : spacing(0),
        padding: hideIcon
            ? spacing(2)
            : align === "left"
                ? spacing(2, 2, 2, 7)
                : spacing(2, 7, 2, 2),
        color: palette.grey["900"],
        fontSize: 16,
        borderRadius: 12,
        position: "relative",
        minHeight: 54,
        borderWidth: 1,
        borderStyle: "solid",
        borderColor: "rgba(0, 0, 0, 0.08)",
        flexShrink: 0,
    }),
    ui_alert__checkboxLabel: {
        "$ui_alert__variant_error &": {
            color: palette.error.main,
        },
        "$ui_alert__variant_info &": {
            color: palette.info.main,
        },
        "$ui_alert__variant_warning &": {
            color: palette.warning.dark,
        },
        color: palette.default.main,
    },
    ui_alert__checkboxLabel__text: {
        fontWeight: 500,
        color: palette.common.black,
    },
    ui_alert__full_height: {
        height: "100%",
    },
    ui_alert__full_width: {
        width: "100%",
    },
    ui_alert__variant_error: {
        backgroundColor: "#FFF3F3",
    },
    ui_alert__variant_info: {
        backgroundColor: "#F0F1F9",
    },
    ui_alert__variant_warning: {
        backgroundColor: "#FFFAEE",
    },
    icon: {
        width: 24,
        height: 24,
        borderRadius: "50%",
        position: "absolute",
        top: 16,
        left: ({ align }) => (align === "left" ? 20 : undefined),
        right: ({ align }) => (align === "right" ? 20 : undefined),
        color: "#ffffff",
        "$ui_alert__variant_info &": {
            background: palette.primary.main,
            transform: "rotate(180deg)",
        },
        "$ui_alert__variant_warning &": {
            background: palette.warning.main,
        },
        "$ui_alert__variant_error &": {
            background: palette.secondary.main,
        },
    },
    title: {
        fontWeight: 500,
        fontSize: 16,
        "$icon + &": {
            marginTop: 2,
        },
        "$ui_alert__variant_info &": {
            color: "#354498",
        },
        "$ui_alert__variant_warning &": {
            color: "#000000",
        },
        "$ui_alert__variant_error &": {
            color: "#D65C5C",
        },
    },
    content: {
        "$title + &": {
            marginTop: 12,
        },
        "$icon + &": {
            marginTop: 1,
        },
        "& .MuiTypography-root": {
            lineHeight: 1.325,
        },
    },
    rememberLabel: ({ hideIcon }) => ({
        width: "auto",
        marginLeft: hideIcon ? 0 : spacing(-5),
    }),
    rememberLabel__btn: {
        minWidth: 0,
    },
}));
//# sourceMappingURL=ui_alert.css.js.map